import React, { forwardRef, useImperativeHandle, useState } from 'react';
import {
  Backdrop,
  ButtonBase,
  Box,
  CircularProgress,
  InputBase,
  Grid,
  Typography
} from '@material-ui/core';

import BoxCenter from './BoxCenter';
import Logo from './Logo';
import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles(theme => ({
  backDrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.25)',
    pointerEvents: 'all',
    zIndex: 2
  },
  bg: {
    alignItems: 'center',
    backgroundImage: 'url(images/forget/framing_4.png)',
    display: 'flex',
    flexDirection: 'column',
    height: 150,
    justifyContent: 'center',
    padding: theme.spacing(1),
    paddingBottom: theme.spacing(4),
    width: 400
  },
  confirmButton: {
    backgroundColor: 'transparent',
    backgroundImage: 'url(images/forget/btn_green_L_normal.png)',
    backgroundSize: 'contain',
    border: 'none',
    color: 'white',
    height: 71,
    outline: 'none',
    paddingBottom: 30,
    fontFamily: 'PJ_WangNgan',
    fontSize: 'x-large',
    width: 151,
    '&:active': {
      paddingBottom: 25,
      backgroundImage: 'url(images/forget/btn_green_L_active.png)'
    }
  },
  resetPassword: {
    color: 'white',
    fontFamily: 'PJ_WangNgan',
    fontSize: 'x-large',
    fontStyle: 'italic',
    marginTop: theme.spacing(0.5)
  },
  root: {
    transform: ({ scale }) => `scale(${window.devicePixelRatio * scale})`,
    pointerEvents: 'all'
  },
  textField: {
    backgroundImage: 'url(images/forget/framing_3.png)',
    height: 50,
    padding: theme.spacing(1),
    width: 350
  }
}));
const ForgetPassword = ({ onSubmit, onBack, scale, loading }, ref) => {
  const {
    backDrop,
    bg,
    confirmButton,
    resetPassword,
    root,
    textField
  } = useStyles({ scale });
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  useImperativeHandle(ref, () => ({
    sendSuccess: () => {
      setSuccess(true);
    },
    setError: err => {
      setErrorMessage(err);
    }
  }));
  const handleTextFieldChange = ({ target }) => {
    setEmail(target.value);
  };
  const handleSubmit = () => {
    if (email !== '') {
      onSubmit(email);
    }
  };
  const handleResetPassword = () => {
    onBack();
  };
  return (
    <BoxCenter>
      <Box
        width={400}
        height={600}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        className={root}
      >
        <Grid container justify="center" alignItems="flex-start">
          <Grid item>
            <Logo />
          </Grid>
          <Grid item>
            <Box height={275} display="flex" alignItems="center">
              <div className={bg}>
                <Box position="absolute" right={25} top="47%">
                  <Typography variant="body1" color="error" align="center">
                    {errorMessage}
                  </Typography>
                </Box>
                <Box m={1}>
                  {!success ? (
                    <>
                      <Typography variant="h5">อีเมล</Typography>
                      <InputBase
                        className={textField}
                        value={email}
                        onChange={handleTextFieldChange}
                        placeholder="example@mail.com"
                      />
                    </>
                  ) : (
                    <Typography variant="h5">
                      การขอเปลี่ยนรหัสผ่านสำเร็จ กรุณาตรวจสอบอีเมลของคุณ
                    </Typography>
                  )}
                </Box>
              </div>
            </Box>
          </Grid>
          <Grid item>
            <Box
              display="flex"
              flexDirection="column"
              height={105}
              justifyContent="flex-end"
            >
              {!success && (
                <button onClick={handleSubmit} className={confirmButton}>
                  ขอเปลี่ยนรหัสผ่าน
                </button>
              )}
              <ButtonBase
                className={resetPassword}
                onClick={handleResetPassword}
              >
                กลับสู่หน้าล็อกอิน
              </ButtonBase>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Backdrop className={backDrop} open={loading}>
        <CircularProgress />
      </Backdrop>
    </BoxCenter>
  );
};
export default forwardRef(ForgetPassword);
